'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msSetFocus', {
    bindings: {
      context: '@',
      isTabsView: '@'
    },
    templateUrl: 'vnext/templates/set-focus.html',
    controller: changeFocusController
  });

  changeFocusController.$inject = ['$log', 'MetadataSvc', 'surveySvc', 'userSvc', '$q', '$state', 'NotifyingSvc', 'eventTrackingSvc', 'activityRouter', '$timeout', '$rootScope', 'trainSvc', 'activitySvc'];

  function changeFocusController($log, MetadataSvc, surveySvc, userSvc, $q, $state, NotifyingSvc, eventTrackingSvc, activityRouter, $timeout, $rootScope, trainSvc, activitySvc) {
    var vm = this;
    var userFocusPromise = void 0;
    var conditionsPromise = void 0;
    var trainPromise = void 0;
    var randomActivityPromise = void 0;
    vm.$onInit = activate;
    vm.updateFocus = updateFocus;
    vm.isTabsView = vm.isTabsView || false;
    vm.selectedTabIndex = 0;
    vm.user = {};
    vm.appMode = 'STANDARD';
    vm.randomActivity = null;
    vm.beginRandomActivity = beginRandomActivity;

    ///////////////////////////////

    function activate() {
      vm.focusSelectId = vm.context + 'FocusSelector';
      userFocusPromise = userSvc.getUser().then(function (user) {
        if (!user) {
          return;
        }
        return user;
      });
      conditionsPromise = MetadataSvc.getTagsByComponentNames(['Condition']).then(function (conditions) {
        vm.conditions = conditions[0];
        vm.conditions.tagList = vm.conditions.tagList.filter(function (t) {
          return t.shortName !== 'condition:smi';
        });
        return conditions[0].tagList;
      });

      if (vm.isTabsView) {
        trainPromise = trainSvc.getTrain().then(function (train) {
          if (train) {
            vm.actualCoreActivity = trainSvc.getActualCoreActivity();
          }
          vm.responseStatus = train.status;
          return train;
        });

        randomActivityPromise = activitySvc.getRandomActivity();
      } else {
        trainPromise = $q.resolve();
        randomActivityPromise = $q.resolve();
      }

      $q.all([userFocusPromise, conditionsPromise, trainPromise, randomActivityPromise]).then(function (data) {
        vm.user = data[0];
        vm.appMode = vm.user && vm.user.accessCode && vm.user.accessCode.applicationMode ? vm.user.accessCode.applicationMode.name : 'STANDARD';
        vm.focus = getFocusByName(data[0].wellnessProgram);

        if (vm.isTabsView) {
          setSelectedTabIndex(data[0].wellnessProgram);
          bindActiveTrainToTab(data[2]);
          vm.randomActivity = data[3];
        }
      });

      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.FOCUS_UPDATED, function (event, data) {
        var newFocus = getFocusByName(data.focus);
        if (newFocus) {
          vm.updateFocus(newFocus);
        }
      });
    }

    function setSelectedTabIndex(wellnessProgram) {
      if (wellnessProgram) {
        for (var i = 0; i < vm.conditions.tagList.length; i++) {
          if (vm.conditions.tagList[i].shortName === wellnessProgram) {
            vm.selectedTabIndex = i;
            return;
          }
        }
      }
    }

    function bindActiveTrainToTab(train) {
      if (train) {
        for (var i = 0; i < vm.conditions.tagList.length; i++) {
          if (vm.conditions.tagList[i].shortName === train.focus) {
            vm.conditions.tagList[i].trainStatus = train.status;
            return;
          }
        }
      }
    }

    function getFocusByName(name) {
      return _.find(vm.conditions.tagList, function (t) {
        return t.shortName === name;
      });
    }

    function updateFocus(newFocus) {
      vm.focus = newFocus;
      // If the user chose a new focus from the list, update their Wellness Program,
      // then start a new train. This will fetch a new train from the server.
      if (newFocus.shortName !== 'condition:all') {
        // 2000ms To let screen reader make announce after focus switch
        $timeout(function () {
          $rootScope.hasFocusSwitched = true;
        }, 2000);
        surveySvc.setWellnessProgram([newFocus]).then(function () {
          $log.debug('update user focus: ', newFocus.shortName);
          eventTrackingSvc.fireEvent('updateFocus', newFocus.shortName, $state.current.name);
          activityRouter.startTrain();
        });
      } else {
        //we are in the ALL case - send them to search
        $state.go('vnext.content.browse.categories');
        eventTrackingSvc.fireEvent('nav', 'activities', 'updateFocus');
      }
    }

    function beginRandomActivity() {
      if (vm.randomActivity) {
        activityRouter.createTrain(vm.randomActivity);
      }
    }

    vm.setOpenSelectState = function () {
      if (vm.context === 'mobileNav') {
        $rootScope.isSelectOpened = true;
      }
    };

    vm.resetFocusSwitchedState = function () {
      if (vm.context === 'headerNav') {
        delete $rootScope.hasFocusSwitched;
      }
    };
  }
})();